import React from 'react';
import { PapiUser } from '@wix/da-papi-types';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import IconButton from '../../../../Button/IconButton';
import Title from '../../../../Popup/_partials/DialogCardLayout/Title';
import BasicUserAvatar from '../../../../User/_partials/BasicUserAvatar';
import s from './SelectedGroupHeader.scss';

export interface Props {
  group: PapiUser;
  resetSelectedGroup: () => void;
}

const SelectedGroupHeader: React.FC<React.PropsWithChildren<Props>> = ({
  group,
  resetSelectedGroup,
}) => {
  return (
    <div className={s['root']}>
      <IconButton className={s['icon-button']} onClick={resetSelectedGroup}>
        <ArrowLeft />
      </IconButton>
      <BasicUserAvatar className={s['avatar']} user={group} size={28} />
      <Title value={group.username!} isConcise={true} />
    </div>
  );
};
SelectedGroupHeader.displayName = 'SelectedGroupHeader';

export default SelectedGroupHeader;
